import moment from "moment";

export const firstWordCapital = (str) => {
  if (typeof str !== "string" || !str.trim()) {
    return str; // Return as is if it's not a valid string
  }

  const [firstWord, ...rest] = str.trim().split(" ");
  return `${firstWord.charAt(0).toUpperCase() + firstWord.slice(1)} ${rest.join(
    " "
  )}`;
};

export const getValueOrFallback = (...values) => {
  if (!values?.length) return "---";
  const result = values
    .filter((value) => value && String(value)?.trim())
    .join(" ")
    .trim();
  return result || "---";
};

export const capitalizeAndJoin = (words, separator = ",") => {
  return words
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(separator);
};

export const isObjectEmpty = (obj) => {
  return obj && Object.keys(obj).length === 0 && obj.constructor === Object;
};

export const isArrayEmpty = (array) => {
  return Array.isArray(array) && array.length === 0;
};

export const formatCurrency = (value, currency = "SAR", locale = "ar-SA") => {
  if (isNaN(value)) return "Invalid value";

  return `${value} ${currency}`;
};

export const formatArrayWithSeparator = (array, separator = ", ") => {
  if (!Array.isArray(array) || array.length === 0) {
    return "";
  }
  return array.filter(Boolean).join(separator); // Join values with the provided separator
};

export const secondsToMinutes = (seconds) => {
  if (isNaN(seconds) || seconds < 0) {
    return "Invalid Input";
  }
  return (seconds / 60).toFixed(2); // Returns up to 2 decimal places
};

// export const getLimitChar = (str = "", length = 2) => {
//   return str?.substring(0, length);
// };

export const getLimitChar = (str = "", length = 10) => {
  if (str.length > length) {
    return str.substring(0, length) + "...";
  }
  return str;
};

export const formatDate = (dateStr = "") => {
  if (!dateStr) return "";
  return moment(dateStr, "DD/MM/YYYY").format("YYYY-MM-DD");
};

// ------------format-date-------------
export const formatDateForInput = (dateStr = "") => {
  if (!dateStr) return "";
  const parsed = moment(dateStr, [
    "DD/MM/YYYY",
    "MM/DD/YYYY",
    "YYYY-MM-DD",
    "DD-MM-YYYY",
    "YYYY/MM/DD",
  ]);
  return parsed.isValid() ? parsed.format("YYYY-MM-DD") : "";
};


// export const handleDownloadFile = async (url = "", fileName = null) => {
//   try {
//     // console.log("url", { url, fileName });
//     // console.log('url', url)
//     const isGif = url.toLowerCase().endsWith(".gif");

//     let updatedFileName = fileName || url.split("/").pop() || "downloaded_file";

//     if (isGif) {
//       // fallback for gif
//       const link = document.createElement("a");
//       link.href = url;
//       link.download = updatedFileName;
//       document.body.appendChild(link);
//       link.click();
//       document.body.removeChild(link);
//     } else {
//       // Fetch and convert other file types to blob
//       const response = await fetch(url);
//       console.log('response', response)
//       if (!response.ok) throw new Error("Network response was not ok");
//       const blob = await response.blob();

//       const blobUrl = URL.createObjectURL(blob);
//       const link = document.createElement("a");
//       link.href = blobUrl;
//       link.download = updatedFileName;
//       document.body.appendChild(link);
//       link.click();
//       document.body.removeChild(link);
//       URL.revokeObjectURL(blobUrl);
//     }
//   } catch (error) {
//     console.error("Error downloading ", error);
//   }
// };


export const formatValidTillDate = (startDate, endDate) => {
  if (!startDate || !endDate) return "";

  const start = moment(startDate).format("DD MMM");
  const end = moment(endDate).format("DD MMM YYYY");

  return `${start} to ${end}`;
};
// ---capitalize-First-letter-----PENDing-to-Pending--------------------------
export const capitalizeFirst = (text) => {
  if (typeof text !== 'string') return '';
  text = text.trim();
  if (text.length === 0) return '';
  return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
}

// --------format-text--------------------
// formatText("amresh pandey", "first"); // Amresh pandey
// formatText("amresh pandey", "title"); // Amresh Pandey
// formatText("amresh pandey", "upper"); // AMRESH PANDEY

export const formatText = (text = "", mode = "first") => {
  if (!text) return "";

  switch (mode) {
    case "first": // Capitalize first letter only
      return text.charAt(0).toUpperCase() + text.slice(1);
    
    case "title": // Capitalize first letter of every word
      return text
        .split(" ")
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ");

    case "upper": // All uppercase
      return text.toUpperCase();

    default:
      return text;
  }
};

// utils/format.js
export const formatPrice = (value) => {
  if (value === undefined || value === null || value === "") return "N/A";
  return Number(value).toFixed(2);
};
